<template>
  <div>
    <forgot-password-component
      v-if="step == 1"
      :is-loading="isLoading"
      @ForgotPassword="forgotPassword"
    />
    <two-step-verification-component
      v-else-if="step == 2"
      :user-email="userEmail"
      :is-loading="isLoading"
      @TwoStepVerification="verifyOtp"
      @resend="resendOtp"
    />
    <reset-password-component
      v-else-if="step == 3"
      :user-email="userEmail"
      :is-loading="isLoading"
      @updatePassword="updatePassword"
    />
  </div>
</template>

<script>
import axios from '@/component/axios'
import jwtDefaultConfig from '@core/auth/jwt/jwtDefaultConfig'
import ForgotPasswordComponent from './ForgotPasswordComponent.vue'
import TwoStepVerificationComponent from './TwoStepVerificationComponent.vue'
import ResetPasswordComponent from './ResetPasswordComponent.vue'

export default {
  components: {
    ForgotPasswordComponent,
    TwoStepVerificationComponent,
    ResetPasswordComponent,
  },
  data() {
    return {
      userEmail: '',
      step: 1,
      isLoading: false,
      verifiedOtp: '',
    }
  },
  methods: {
    async forgotPassword(userEmail) {
      this.userEmail = userEmail
      this.isLoading = true
      try {
        const res = await axios.post(jwtDefaultConfig.forgotPasswordEndpoint, { email: userEmail })
        if (res.data?.success) {
          this.step = 2
        } else {
          this.showError(res.data?.message || 'Unable to send reset code')
        }
      } catch (error) {
        this.showError(error.response?.data?.message || 'Unable to send reset code')
      } finally {
        this.isLoading = false
      }
    },
    verifyOtp(otp) {
      this.verifyOtpCode(otp)
    },
    async verifyOtpCode(otp) {
      this.isLoading = true
      try {
        const res = await axios.post(jwtDefaultConfig.verifyForgotPasswordOtpEndpoint, {
          email: this.userEmail,
          otp,
        })
        if (res.data?.success) {
          this.verifiedOtp = otp
          this.$swal({
            title: 'Email Verified',
            text: 'Your email has been verified. You can now set a new password.',
            icon: 'success',
            customClass: { confirmButton: 'btn btn-primary poda-btn-primary' },
            buttonsStyling: false,
          })
          this.step = 3
        } else {
          this.showError(res.data?.message || 'Invalid verification code')
        }
      } catch (error) {
        this.showError(error.response?.data?.message || 'Invalid verification code')
      } finally {
        this.isLoading = false
      }
    },
    async resendOtp() {
      if (!this.userEmail) {
        this.step = 1
        return
      }
      await this.forgotPassword(this.userEmail)
    },
    async updatePassword(password, confirmPassword) {
      this.isLoading = true
      try {
        const res = await axios.post(jwtDefaultConfig.resetPasswordEndpoint, {
          email: this.userEmail,
          otp: this.verifiedOtp,
          new_password: password,
          confirm_password: confirmPassword,
        })
        if (res.data?.success) {
          this.$router.push({ name: 'auth-login' })
          this.$swal({
            title: 'Success',
            text: res.data.message || 'Password reset successfully',
            icon: 'success',
            customClass: { confirmButton: 'btn btn-success' },
            buttonsStyling: false,
          })
        } else {
          this.showError(res.data?.message || 'Unable to reset password')
        }
      } catch (error) {
        this.showError(error.response?.data?.message || 'Unable to reset password')
      } finally {
        this.isLoading = false
      }
    },
    showError(message) {
      this.$swal({
        title: 'Error',
        timer: 5000,
        text: message,
        icon: 'error',
        customClass: { confirmButton: 'btn btn-danger' },
        buttonsStyling: false,
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
